// Polski FAQ na stronę kontaktową
export const DEFAULT_FAQS_PL = [
  {
    question: "Jak najłatwiej dostać się do Was w Råstrand, Laponia?",
    answer: [
      "Odległość z Malmö do naszego domu to około 1500 km.",
      "Najszybszym i najwygodniejszym sposobem jest samolot. Bilet do Laponii kosztuje niewiele więcej niż dwa pełne baki benzyny i jest bardzo polecany.",
      "Zawsze odbieramy i odwozimy naszych gości na lotnisko Skellefteå, Luleå lub Lycksele."
    ]
  },
  {
    question: "Jak dolecieć do Was?",
    answer: [
      "W zależności od miejsca zamieszkania leć do Arlandy w Sztokholmie.",
      "Stamtąd poleć linią Amapola do Lycksele (100 km od nas). Transfer jest wliczony w pakiet zimowy, a bilety można zarezerwować na amapola.nu.",
      "Możesz też polecieć do Skellefteå lub Luleå i kontynuować podróż wynajętym samochodem. Te lotniska są dalej, ale bilety bywają bardzo tanie. Chętnie pomożemy znaleźć najlepsze opcje."
    ]
  },
  {
    question: "Czy mogę przyjechać własnym samochodem?",
    answer: [
      "Tak, ale upewnij się, że masz dobre opony zimowe. Uważaj na dzikie zwierzęta na drogach.",
      "Z Sztokholmu do Råstrand jedzie się samochodem około 9–10 godzin.",
      "Råstrand najłatwiej znaleźć, wpisując 'Cold Experience Lapland' w Google Maps."
    ]
  },
  {
    question: "Czy ubrania na skuter śnieżny, buty i kaski są wliczone?",
    answer: [
      "Tak, zapewniamy odzież wierzchnią. Ubrania na skuter śnieżny są ciepłe – pod spodem nosisz bieliznę termiczną i miękkie ubrania."
    ]
  },
  {
    question: "Jakie ubrania powinienem zabrać?",
    answer: [
      "Zalecamy zabrać:",
      "1. Wysokiej jakości bieliznę termiczną",
      "2. Zwykłe skarpetki",
      "3. Sweter lub polar",
      "4. Ciepłe spodnie polarowe / miękkie spodnie",
      "5. Ciepłe wełniane skarpetki",
      "6. Kurtka zimowa lub kombinezon narciarski",
      "7. Buty zimowe / trapery",
      "8. Czapka i kominiarka do noszenia pod kaskiem",
      "9. Szalik",
      "10. Dobre rękawiczki",
      "11. Okulary przeciwsłoneczne lub gogle narciarskie",
      "12. Strój kąpielowy",
      "Punkty 6 i 7 używane są na zewnątrz, gdy nie jeździsz skuterem śnieżnym. Na wycieczki skuterem śnieżnym otrzymasz kombinezon, buty i kask.",
      "W Szwecji zdejmujemy buty w domu, więc warto zabrać ciepłe kapcie lub grube skarpetki do użytku w pomieszczeniach."
    ]
  },
  {
    question: "Czy jest coś, czego nie muszę zabierać?",
    answer: [
      "Zapewniamy pościel, ręczniki, szlafroki i kapcie.",
      "Suszarka do włosów jest dostępna w łazience.",
      "Kawa, herbata, woda i sok są wliczone w pełne wyżywienie."
    ]
  },
  {
    question: "Co nie jest wliczone w pełne wyżywienie?",
    answer: [
      "Napoje alkoholowe nie są wliczone. Zabierz gotówkę, jeśli chcesz je kupić."
    ]
  },
  {
    question: "Czy potrzebuję dodatkowego ubezpieczenia?",
    answer: [
      "Tak, kup ubezpieczenie podróżne obejmujące aktywności przygodowe.",
      "Sprawdź również, czy Twoje ubezpieczenie zdrowotne obowiązuje za granicą i zabierz dowód ubezpieczenia."
    ]
  },
  {
    question: "Czy potrzebuję specjalnego prawa jazdy na skuter śnieżny?",
    answer: [
      "Nie, wystarczy zwykłe prawo jazdy.",
      "Wszyscy kierowcy muszą mieć przy sobie prawo jazdy. Ponieważ zawsze jeździsz z naszym przewodnikiem, wystarczy, że przewodnik ma wszystkie niezbędne pozwolenia.",
      "Sprawdź również, czy Twój paszport lub dowód osobisty jest ważny."
    ]
  },
  {
    question: "Czy mogę używać obcej waluty w Szwecji?",
    answer: [
      "Nie, musisz wymienić pieniądze na korony szwedzkie (SEK), aby robić zakupy u nas lub w sklepie wiejskim.",
      "Większość innych sklepów akceptuje karty VISA i Mastercard."
    ]
  }
];
